import React from 'react';
import { Col, Form } from 'antd';

import { FormItem } from '../../../styles';
import { CheckboxCard } from './CheckboxCard';
import { useCategoryContext } from '../context';
import { RosaElementEnum } from '../../../constants';
import { useRosaContext } from '../../../../../context';
import { Element } from '../../../../../hooks/useGetElements';
import { useUpdateElement } from '../../../../../hooks/useUpdateElement';

const { useFormInstance } = Form;

interface OptionalElementProps {
	name: string[];
	elementProps: Element;
}

export function OptionalElement({ elementProps, name }: Readonly<OptionalElementProps>) {
	const form = useFormInstance();
	const { fieldName, elements } = useCategoryContext();
	const { organization_id, company_id, file_id } = useRosaContext();

	const { mutateAsync: updateElement } = useUpdateElement({ organization_id, company_id, report_id: file_id });

	async function handleSubmitNotRequiredElement(): Promise<void> {
		const value = await form.getFieldValue([...fieldName, 'not_required', elementProps.name]);

		const selectedElement = elements.not_required.find((element) => element.name === elementProps.name);

		const payload = {
			evaluation_element: {
				id: selectedElement?.id ?? '',
				checked: value
			}
		};

		await updateElement(payload);
	}

	let totalItems = elements?.not_required.length;

	function handleItemSize(): number {
		const hasFarAwayElement = elements?.not_required.some((e) => e.name === RosaElementEnum.FAR_AWAY);

		if (hasFarAwayElement) {
			return 8;
		}

		if (totalItems === 1) {
			return 6;
		}

		return 24 / totalItems;
	}

	if (elementProps.name === RosaElementEnum.FAR_AWAY) {
		return <></>;
	}

	return (
		<Col span={handleItemSize()}>
			<FormItem valuePropName="checked" name={name}>
				<CheckboxCard
					element={elementProps}
					wrap={totalItems === 4}
					onChange={handleSubmitNotRequiredElement}
				/>
			</FormItem>
		</Col>
	);
}
